import { readCookies as j } from "./cookies/cookie-parser-util.js";
import { GA_CLIENT_ID_COOKIE_NAME as B, parseGaClientIdCookie as v } from "./cookies/ga-client-id.js";
import { ErrorResponse as G, createErrorResponse as M } from "./errorResponse.js";
import { isValidRepub as l } from "@cx-web/utils";
import { REPUBS as s } from "@cx-modules/constants";
import { getUserGroup as y } from "./getUserGroup.js";
import { SUPPORTED_REPUB_NAMES as c, REPUB_COUNTRY as R } from "@cx-web/domain-types";
const m = (e) => {
  if (e.status !== "rejected")
    return e.value;
}, U = (e, t) => {
  const r = m(e);
  if (r == null)
    throw new Response(null, { status: 500, statusText: t });
  return r;
}, S = (e, t) => {
  if (e.status === "rejected")
    throw e.reason instanceof Response ? e.reason : new Response(null, { status: 500, statusText: t });
  if (e.value == null)
    throw new Response(null, { status: 500, statusText: t });
  return e.value;
};
function h(e) {
  var r;
  const t = (r = e.pathname.split("/")[1]) == null ? void 0 : r.toUpperCase();
  return !l(t) || !s[t] ? s.OC.name : t;
}
const w = (e) => typeof e == "object" && e !== null && "status" in e, b = [
  ["OC", "/"],
  ["US", "us/"],
  ["DE", "de/"],
  ["CO", "co/"],
  ["AU", "au/"],
  ["NZ", "nz/"],
  ["IN", "in/"],
  ["PT", "pt/"],
  ["ZA", "za/"],
  ["KE", "ke/"],
  ["NG", "ng/"],
  ["NL", "nl/"],
  ["FR", "fr/"],
  ["SE", "se/"],
  ["SM", "sm/"],
  ["CX", "cx/"],
  ["CA", "ca/"],
  ["ES", "es/"],
  ["IT", "it/"],
  ["BR", "br/"],
  ["GZ", "/"],
  ["WS", "/"]
];
function p(e, t) {
  const r = b.find(([o]) => o === e);
  if (!r) return t ? "/" : "";
  const n = r[1];
  return n === "/" ? t ? "/" : "" : `/${n.replace(/\/$/, "")}`;
}
function d(e) {
  return p(e, !1);
}
function C(e) {
  return p(e, !0);
}
function E(e) {
  const t = Object.entries(s).reduce((u, [a, f]) => ({
    ...u,
    [a]: e === f.name
  }), {}), r = e.toLowerCase(), n = c.some((u) => t[u]), o = n ? R[e] : "uk";
  return {
    repubIs: t,
    repubIsOCPlus: n,
    repubPath: d(e),
    repubHomeUrl: C(e),
    repubLowerCase: r,
    repubCountry: o
  };
}
function I(e) {
  const { repubIsOCPlus: t } = E(e);
  return t;
}
function N(e) {
  return !!s[e];
}
let i = /* @__PURE__ */ new WeakSet();
function A(e, t, r) {
  if (!i.has(e)) {
    e.init({
      lng: t,
      fallbackLng: "en-US",
      defaultNS: "label",
      resources: r,
      initImmediate: !1
    }), i.add(e);
    return;
  }
  e.language !== t && e.changeLanguage(t);
  for (const [n, o] of Object.entries(r))
    if (o)
      for (const [u, a] of Object.entries(o))
        e.addResourceBundle(n, u, a, !1, !0);
}
export {
  G as ErrorResponse,
  B as GA_CLIENT_ID_COOKIE_NAME,
  M as createErrorResponse,
  m as getPromiseResult,
  h as getRepubFromURL,
  C as getRepubHomeUrl,
  E as getRepubMetaFromRepub,
  d as getRepubPath,
  y as getUserGroup,
  w as isErrorWithStatus,
  I as isOcPlusRepub,
  N as isValidRepub,
  v as parseGaClientIdCookie,
  j as readCookies,
  b as repubs,
  S as requireErrorAwarePromiseResult,
  U as requirePromiseResult,
  A as updateI18nSingleton
};
